import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-pantalla-completa',
  templateUrl: './pantalla-completa.component.html',
  styleUrls: ['./pantalla-completa.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PantallaCompletaComponent {}
